import { render, staticRenderFns } from "./claim-goods-case-template.vue?vue&type=template&id=6b5778de&scoped=true&"
import script from "./claim-goods-case-template.vue?vue&type=script&lang=js&"
export * from "./claim-goods-case-template.vue?vue&type=script&lang=js&"
import style0 from "./claim-goods-case-template.vue?vue&type=style&index=0&id=6b5778de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5778de",
  null
  
)

export default component.exports